module.exports = function() {
	return new Worker(__webpack_public_path__ + "7746d934ca489217eec0.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./worker.js
 ** module id = 3
 ** module chunks = 0
 **/